import { CollapsedButton } from "../../../../../common/ChatComponents/MessageSendingInput/Actions/CollapsedButton";
import { SendMessageButton } from "../../../../../common/ChatComponents/MessageSendingInput/Actions/SendMessageButton";
import styles from "./styles.module.css";

interface Props {
  handleSendTask: () => void;
  handleCollapsedInput: () => void;
  isDisabled?: boolean;
  className?: string;
}

export const ResultInputActions = ({
  handleSendTask,
  handleCollapsedInput,
  isDisabled,
  className,
}: Props) => {
  return (
    <div className={styles["actions-container"]}>
      <CollapsedButton handleCollapsedInput={handleCollapsedInput} />
      <SendMessageButton sendMessage={handleSendTask} disabled={isDisabled} />
    </div>
  );
};
